import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({ providedIn: "root" })
export class CustomValidators {
    constructor() {}

    passwordMatchValidator(passwordKey: string, confirmPasswordKey: string): ValidatorFn {
        return (formGroup: AbstractControl): ValidationErrors | null => {
            const confirmPasswordcontrol = formGroup.get(confirmPasswordKey);
            const password = formGroup.get(passwordKey)?.value;
            const confirmPassword = confirmPasswordcontrol?.value;
            
            if (password !== confirmPassword) {
                confirmPasswordcontrol?.setErrors({ passwordMismatch: true });
                return { passwordMismatch: true };
            } else {
                // Clear any previous error if passwords match
                if (confirmPasswordcontrol?.hasError('passwordMismatch')) {
                    const errors = { ...confirmPasswordcontrol.errors };
                    delete errors['passwordMismatch'];
                    confirmPasswordcontrol?.setErrors(Object.keys(errors).length ? errors : null);
                }
                return null;
            }
        };
    }

    /**
     * Validates a password against a custom policy:
     * - At least 10 characters long
     * - Contains at least one lowercase letter
     * - Contains at least one uppercase letter
     * - Contains at least one number
     * - Contains at least one special character from the set (^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~  + =) or a non-leading, non-trailing space character.
    **/
    passwordPolicyValidator(control: AbstractControl): ValidationErrors | null {
        const password = control.value;

        if (!password) return null;

        const specialChars = `^$*.[]{}()?-"!@#%&/\\,><':;|_~\`+=`;
        const specialCharsRegex = new RegExp(`[${specialChars.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}]`);

        const isValid = 
            password.length >= 10 &&
            /[a-z]/.test(password) &&
            /[A-Z]/.test(password) &&
            /\d/.test(password) &&
            (
                specialCharsRegex.test(password) ||
                (/\s/.test(password) && !/^\s|\s$/.test(password)) // space not at start or end
            );

        return isValid ? null : { passwordPolicy: true };
    }

    /* Validates a Cognito username:
     * - Must be between 1 and 128 characters long
     * - Can contain letters, numbers, periods (.), underscores (_), at signs (@), and hyphens (-)
     * - Cannot start or end with a period (.)
     * - Cannot contain consecutive periods (..)
     * - Cannot contain spaces
    */
    cognitoUsernameValidator(control: AbstractControl): ValidationErrors | null {
        const username = control.value;
        if (!username) return null;

        const regex = /^(?![.])[a-zA-Z0-9._-]{1,128}(?<![.])$/;

        return regex.test(username) ? null : { invalidCognitoUsername: true };
    }
}